import client from '../client';

export const schoolApi = {
  create: async (data) => {
    const response = await client.post('/schools/', data);
    return response.data;
  },

  getAll: async (page = 1, size = 100) => {
    const response = await client.get(`/schools/list-schools?page=${page}&size=${size}`);
    return response.data;
  },

  getById: async (id) => {
    try {
      const response = await client.get(`/schools/${id}`);
      return response.data;
    } catch (err) {
      // Fallback to searching from list-schools if direct ID endpoint is unavailable
      const listRes = await client.get('/schools/list-schools?page=1&size=100');
      const found = (listRes.data?.items || []).find((s) => s.id === id);
      if (found) return found;
      throw err;
    }
  },

  update: async (id, data) => {
    const response = await client.put(`/schools/${id}`, data);
    return response.data;
  },

  createConfiguration: async (id, data) => {
    const isFormData = data instanceof FormData;
    const response = await client.post(`/schools/${id}/configuration`, data, {
      headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return response.data;
  },

  updateConfiguration: async (id, data) => {
    const isFormData = data instanceof FormData;
    const response = await client.put(`/schools/${id}/configuration`, data, {
      headers: isFormData ? { 'Content-Type': 'multipart/form-data' } : {},
    });
    return response.data;
  },

  getConfiguration: async (id) => {
    const response = await client.get(`/schools/${id}/configuration`);
    return response.data;
  },
};
